import InitComponent from './InitComponent';

export default InitComponent;
